<et-step-layout [data]="data">

  <et-keyword-list [data]="data"
                   (keywordsCountChanged)="onKeywordCountChanged()"
                   subHeader="Keywords from your paper. Will be used in a paper version."
                   i18n-subHeader>
  </et-keyword-list>

</et-step-layout>